export default "__VITE_ASSET__Ba$LAIQ5__"